import color from "../../constants/color";

const styles = {
  modalPaper: {
    "& .MuiDialog-paper": {
      borderRadius: "20px",
      width: "100%",
      maxWidth: "550px",
      minWidth: "450px",
    },
    "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
      borderRadius: "20px",
      width: "100%",
      maxWidth: "550px",
      minWidth: "450px",
    },
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    py: 2,
    "& .css-1dzapu9-MuiTypography-root-MuiDialogTitle-root": {
      marginBottom: 2,
    },
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    pr: 1,
  },
  closeIcon: {
    position: "absolute",
    right: 15,
    top: 15,
    color: color.card,
    backgroundColor: color.text,
    width: "27px",
    height: "27px",
    "&:hover": {
      backgroundColor: color.text,
    },
  },
  radioGroupContainer: {
    mb: 3,
    mt: 1,
    px: 1,
  },
  radioGroup: {
    width: "100%",
  },
  radioButtonsGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    "& > *:nth-of-type(1), & > *:nth-of-type(2)": {
      flex: "0 0 auto",
      minWidth: "140px",
    },
    "& > *:nth-of-type(3)": {
      flex: "0 0 100%",
      marginTop: 0,
    },
  },
  radio: {
    color: "#878787",
    "&.Mui-checked": {
      color: "#28AA4A",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  radioLabel: {
    margin: 0,
    "& .MuiFormControlLabel-label": {
      fontSize: "14px",
      fontWeight: "500",
      color: color.text,
    },
  },
  fieldContainer: {
    mb: 2.5,
    px: 1,
  },
  label: {
    fontSize: "13px",
    fontWeight: "500",
    color: color.text,
    mb: 1,
  },
  select: {
    width: "100%",
    borderRadius: "10px",
    height: "48px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "12px 14px",
    },
    "& .MuiSelect-select": {
      padding: "12px 14px",
    },
  },
  menuItem: {
    fontSize: "13px",
    my: "8px",
    fontWeight: "500",
    width: "100%",
    height: "40px",
  },
  textField: {
    borderRadius: "10px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      height: "48px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 14px",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "12px 14px",
    },
  },
  textArea: {
    borderRadius: "10px",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
    },
    "& .MuiOutlinedInput-input": {
      padding: "14px",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "14px",
    },
  },
  actionButtons: {
    justifyContent: "center",
    mx: 2,
    pb: "24px",
    pt: "8px",
    gap: 2,
  },
  cancelButton: {
    backgroundColor: "#E8E8E8",
    color: "#333333",
    textTransform: "none",
    borderRadius: "25px",
    px: 4,
    py: 1,
    minWidth: "120px",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#D8D8D8",
    },
  },
  saveButton: {
    backgroundColor: "#28AA4A",
    color: "#ffffff",
    textTransform: "none",
    borderRadius: "25px",
    px: 4,
    py: 1,
    minWidth: "120px",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#22993F",
    },
    "&:disabled": {
      backgroundColor: "#A5D6A7",
      color: "#ffffff",
    },
  },
};

export default styles;

